





















import {Component, Mixins} from 'vue-property-decorator'
import ModalBaseBody from '../ModalBaseBody.vue'
import SubjectEmail from '../SubjectEmail.vue'
import modalStepMixin from '@/mixins/modalStepMixin'

@Component({
  components: {
    ModalBaseBody,
    SubjectEmail
  }
})
export default class ModalConsultationEmail extends Mixins(modalStepMixin) {}
